// Mirrors CountryUtil::getNationalities() in the backend (quoting-be/app/Utils/CountryUtil.php)
// so nationality -> country-of-residence comparisons on the frontend match the backend's zone
// lookups. Keep the two in sync.
const NATIONALITIES = {
  'afghan': 'Afghanistan',
  'algerian': 'Algeria',
  'albanian': 'Albania',
  'antiguan & barbudan': 'Antigua and Barbuda',
  'australian': 'Australia',
  'argentine': 'Argentina',
  'austrian': 'Austria',
  'azerbaijani': 'Azerbaijan',
  'bahraini': 'Bahrain',
  'bangladeshi': 'Bangladesh',
  'belarusian': 'Belarus',
  'belgian': 'Belgium',
  'bolivian': 'Bolivia',
  'brazilian': 'Brazil',
  'bruneian': 'Brunei',
  'bulgarian': 'Bulgaria',
  'cambodian': 'Cambodia',
  'cameroonian': 'Cameroon',
  'canadian': 'Canada',
  'caymanian': 'Cayman Islands',
  'chinese': 'China',
  'colombian': 'Colombia',
  'costa rican': 'Costa Rica',
  'croatian': 'Croatia',
  'chilean': 'Chile',
  'cypriot': 'Cyprus',
  'emirati': 'United Arab Emirates',
  'danish': 'Denmark',
  'egyptian': 'Egypt',
  'eritrean': 'Eritrea',
  'timorese': 'East Timor',
  'equatoguinean': 'Equatorial Guinea',
  'estonian': 'Estonia',
  'faroese': 'Faroe Islands',
  'finnish': 'Finland',
  'french': 'France',
  'fijian': 'Fiji',
  'german': 'Germany',
  'georgian': 'Georgia',
  'greek': 'Greece',
  'guyanese': 'Guyana',
  'hong konger': 'Hong Kong',
  'hungarian': 'Hungary',
  'indian': 'India',
  'indonesian': 'Indonesia',
  'iranian': 'Iran',
  'iraqi': 'Iraq',
  'irish': 'Ireland',
  'israeli': 'Israel',
  'italian': 'Italy',
  'japanese': 'Japan',
  'jordanian': 'Jordan',
  'kazakhstani': 'Kazakhstan',
  'kenyan': 'Kenya',
  'korean': 'Korea, South',
  'kuwaiti': 'Kuwait',
  'latvian': 'Latvia',
  'lebanese': 'Lebanon',
  'libyan': 'Libya',
  'lithuanian': 'Lithuania',
  'malagasy': 'Madagascar',
  'malaysian': 'Malaysia',
  'maldivian': 'Maldives',
  'maltese': 'Malta',
  'mauritian': 'Mauritius',
  'mexican': 'Mexico',
  'mongolian': 'Mongolia',
  'montenegrin': 'Montenegro',
  'moroccan': 'Morocco',
  'burmese': 'Myanmar (Burma)',
  'nepali': 'Nepal',
  'dutch': 'Netherlands',
  'new caledonian': 'New Caledonia',
  'new zealander': 'New Zealand',
  'nigerian': 'Nigeria',
  'niuean': 'Niue',
  'norwegian': 'Norway',
  'panamanian': 'Panama',
  'pakistani': 'Pakistan',
  'peruvian': 'Peru',
  'filipino': 'Philippines',
  'polish': 'Poland',
  'portuguese': 'Portugal',
  'romanian': 'Romania',
  'russian': 'Russia',
  'saudi': 'Saudi Arabia',
  'scottish': 'United Kingdom',
  'serbian': 'Serbia',
  'seychellois': 'Seychelles',
  'singaporean': 'Singapore',
  'slovak': 'Slovak Republic',
  'slovenian': 'Slovenia',
  'solomon islander': 'Solomon Islands',
  'south african': 'South Africa',
  'spanish': 'Spain',
  'sri lankan': 'Sri Lanka',
  'swedish': 'Sweden',
  'swiss': 'Switzerland',
  'syrian': 'Syria',
  'taiwanese': 'Taiwan',
  'thai': 'Thailand',
  'togolese': 'Togo',
  'tongan': 'Tonga',
  'trinidadian & tobagonian': 'Trinidad & Tobago',
  'tunisian': 'Tunisia',
  'turkish': 'Turkey',
  'ugandan': 'Uganda',
  'ukrainian': 'Ukraine',
  'british': 'United Kingdom',
  'american': 'United States of America',
  'ni-vanuatu': 'Vanuatu',
  'venezuelan': 'Venezuela',
  'vietnamese': 'Vietnam',
  'zambian': 'Zambia',
  'zimbabwean': 'Zimbabwe'
};

export default function nationalityToCountry(nationality) {
  if (!nationality) return null;

  return NATIONALITIES[nationality.trim().toLowerCase()] || null;
}
